export const RecoilAtomKeys = {
  SNACKBAR: 'snackbar',
} as const
